import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import firebase from 'firebase'
import moment from 'moment'
import Polyglot from 'node-polyglot'
import LOCALE_EN_GB from './resources/locales/en-GB'
import LOCALE_IT_IT from './resources/locales/it-IT'
import LOCALE_PT_PT from './resources/locales/pt-PT'
import LOCALE_FR_FR from './resources/locales/fr-FR'
import App from './components/general/App/App'

import './resources/web-fonts-with-css/css/fontawesome-all.css'

import 'jquery/src/jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'
import 'bootstrap/dist/js/bootstrap'

export const storageKey = 'goodStuff'
export const languagePreference = 'risoLanguage'

const configuration = {
  apiKey: 'AIzaSyDAaXcYnxPfG_VKh1eh1CLnqs79zFFE0bA',
  authDomain: 'cards-configuration.firebaseapp.com',
  databaseURL: 'https://cards-configuration.firebaseio.com',
  projectId: 'cards-configuration',
  storageBucket: 'cards-configuration.appspot.com',
  messagingSenderId: '1057398774537'
}

const data = {
  apiKey: 'AIzaSyDNOM503AXUu5PiMBvXKyon6n5bEJRQMKg',
  authDomain: 'cards-data-c8758.firebaseapp.com',
  databaseURL: 'https://cards-data-c8758.firebaseio.com',
  projectId: 'cards-data-c8758',
  storageBucket: 'cards-data-c8758.appspot.com',
  messagingSenderId: '182800749240'
}

firebase.initializeApp(configuration)

let locale = 'pt'

if (window.localStorage.getItem(languagePreference)) {
  locale = window.localStorage.getItem(languagePreference)
}

export function getLocale () {
  return locale
}

let polyglot = new Polyglot({locale: locale})

getPolyglotPhrasesFromDatabase(locale)

function getPolyglotPhrasesFromDatabase (locale) {
  const rootRef = firebase.database().ref()
  const config = rootRef.child('riso').child('translationKeys').child(locale)
  config.on('value', dataSnapshot => {
    const phrases = dataSnapshot.val()
    if (phrases) {
      polyglot.extend(phrases)
      polyglot.extend({
        'staticFields': {
          'numMonths': `%{smart_count}  ${phrases.staticFields['commonFields'].month} |||| %{smart_count}  ${phrases.staticFields['commonFields'].months} `,
          'numWeeks': `%{smart_count}  ${phrases.staticFields['commonFields'].week} |||| %{smart_count}  ${phrases.staticFields['commonFields'].weeks} `,
          'numDays': `%{smart_count}  ${phrases.staticFields['commonFields'].day} |||| %{smart_count}  ${phrases.staticFields['commonFields'].days} `,
          'numYears': `%{smart_count}  ${phrases.staticFields['commonFields'].year} |||| %{smart_count}  ${phrases.staticFields['commonFields'].years} `
        }
      })
    }
  })
}

export function changePolyglotValues (newValue) {
  polyglot = newValue
  return polyglot
  // console.log(polyglot)
}
export function changeMomentLocale (locale) {
  if (locale === 'it') {
    moment.updateLocale('it', LOCALE_IT_IT)
  } else if (locale === 'pt') {
    moment.updateLocale('pt', LOCALE_PT_PT)
  } else if (locale === 'fr') {
    moment.updateLocale('fr', LOCALE_FR_FR)
  } else {
    moment.updateLocale('en', LOCALE_EN_GB)
  }
}

export { polyglot, locale }

changeMomentLocale(locale)

let dataApp = firebase.initializeApp(data, 'data')

const dataAppDatabase = dataApp.database()
const dataAppStorage = dataApp.storage()
const dataAppAuth = dataApp.auth()

const patientsDatabase = dataApp.database().ref().child('riso').child('patientsByCountry').child(locale)

export { dataAppDatabase, dataAppStorage, dataAppAuth, patientsDatabase }

export const isAuthenticated = () => {
  return dataAppAuth.currentUser || window.localStorage.getItem(storageKey)
}

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js